module.exports = __webpack_public_path__ + "img/unlocked_circle.8dbb68f9.svg";